import { useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import { prop } from 'ramda';
import { useGameConfigurationSelector, useDeviceSelector } from 'js/store/hooks';

import { useGetGameConfig } from './useGetGameConfig';

export const useGetUrlTypeList = () => {
    const { search } = useLocation();
    const searchParams = new URLSearchParams(search);
    const preview = searchParams.get('preview');
    const isDesktop = useDeviceSelector(prop('isDesktop'));
    const gameTypes = useGameConfigurationSelector(prop('gameTypes'));
    const getGameConfig = useGetGameConfig();

    return useCallback(({ gameCode, mode }: { gameCode: string; mode?: number }): string[] => {
        const gameConfig = getGameConfig(gameCode);
        const gameType = isDesktop ? gameConfig?.desktopGameType : gameConfig?.mobileGameType;
        const provider = gameTypes.find(item => item.name === gameType);

        if (!provider) {
            return [];
        }

        let urlType;

        if (Number(preview) === 1) {
            urlType = provider[mode ? 'previewRealPlayUrl' : 'previewDemoPlayUrl'];
        }

        urlType = urlType || provider[mode ? 'realPlayUrl' : 'demoPlayUrl'];

        return [urlType];
    }, [gameTypes, preview, getGameConfig, isDesktop]);
};

